module.exports = __webpack_public_path__ + "static/media/AC.93ff6815.png";